import { render, staticRenderFns } from "./donation-info.vue?vue&type=template&id=547f8935&"
import script from "./donation-info.vue?vue&type=script&lang=js&"
export * from "./donation-info.vue?vue&type=script&lang=js&"
import style0 from "./donation-info.vue?vue&type=style&index=0&id=547f8935&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports